import React from "react";
import { useState } from "react";
import { database, ref, push } from "./firebaseConfig";

import picTwo from "../images/pic-2.jpg";

function Contact() {
  // Form
  let [formData, setFormData] = useState({
    email: "",
    phone: "",
    name: "",
    message: "",
  });

  let [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  let handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await push(ref(database, "Contact_Info"), formData);
      setSubmitted(true);
      setFormData({
        email: "",
        phone: "",
        name: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("Something went wrong, Please try again.");
    }
  };

  // Newsletter

  let [emailData, setEmail] = useState({
    email: "",
  });

  let [emailSubmitted, submitEmail] = useState(false);

  function handleEmailChange(e) {
    setEmail({ ...emailData, [e.target.name]: e.target.value });
  }

  let handleEmailSubmit = async (e) => {
    e.preventDefault();

    try {
      await push(ref(database, "Newsletter"), emailData);
      submitEmail(true);
      setEmail({
        email: "",
      });
    } catch (error) {
      console.error("Error submitting form: ", error);
      alert("Something went wrong, Please try again.");
    }
  };

  return (
    <div style={{ border: "2px solid rgb(29, 65, 48, 0.8)" }}>
      <section
        data-aos="fade-up"
        data-aos-delay="150"
        data-aos-duration="1500"
        className="heading-section"
      >
        <div className="background contact-bg"></div>
        <div className="overlay"></div>
        <div className="content text-center">
          <p className="page-title">Contact Us</p>
          <span className="sub-tagline">We’re here to grow with you 🌱</span>
        </div>
      </section>

      <section
        className="contact-us py-5"
        style={{ borderTop: "2px solid rgb(29, 65, 48, 0.8)" }}
      >
        <div className="container">
          <div className="row g-4 align-items-stretch mt-5">
            {/* Contact Form */}
            <div className="col-12 col-lg-6 d-flex">
              <div className="form-column flex-fill">
                <div className="card p-4 shadow-sm">
                  <h2
                    className="main-heading text-center mb-3"
                    data-aos="fade-up"
                    data-aos-delay="280"
                    data-aos-duration="1500"
                  >
                    Get In Touch 🌱
                  </h2>
                  <p
                    className="sub-text text-center mb-4"
                    data-aos="fade-up"
                    data-aos-delay="280"
                    data-aos-duration="1500"
                  >
                    We’d love to hear from you!
                  </p>

                  {!submitted ? (
                    <form
                      className="w-100"
                      data-aos="fade-up"
                      data-aos-delay="300"
                      data-aos-duration="1500"
                      onSubmit={handleSubmit}
                    >
                      <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-3">
                          <input
                            type="tel"
                            name="phone"
                            className="form-control"
                            placeholder="Phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-12 mb-3">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            placeholder="Name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-12 mb-4">
                          <textarea
                            name="message"
                            className="form-control"
                            rows="4"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div className="col-12 text-start">
                          <button
                            type="submit"
                            className="btn btn-success px-4"
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className="text-center">
                      <h2 className="px-5">Thank you for reaching out! 🌿</h2>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Newsletter Signup */}
            <div className="col-12 col-lg-6">
              <div className="newsletter-column">
                <div className="card position-relative">
                  <img src={picTwo} alt="Newsletter" />
                  <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
                  <div className="content text-white text-center">
                    <p className="heading">Our Newsletters</p>
                    <p>
                      Be the first to hear about our eco-friendly tips, product
                      updates, and inspiring sustainability stories—right to
                      your inbox.
                    </p>

                    {!emailSubmitted ? (
                      <form onSubmit={handleEmailSubmit}>
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          value={emailData.email}
                          onChange={handleEmailChange}
                          required
                        />
                        <button type="submit">Submit</button>
                      </form>
                    ) : (
                      <div className="card p-3 shadow-md text-center bg-white bg-opacity-75 rounded">
                        <p className="mb-0">
                          You're subscribed — exciting updates are on the way!
                          🌿
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-info mt-5">
        <div className="container">
          <div
            data-aos="fade-up"
            data-aos-delay="350"
            data-aos-duration="1500"
            className="row"
          >
            <div className="col-12 col-md-4 mb-4">
              <div className="card card-one contact-card text-center">
                <div className="icon-wrapper mb-3">
                  <svg
                    width="100%"
                    height="8vh"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M16.1007 13.359L15.5719 12.8272H15.5719L16.1007 13.359ZM16.5562 12.9062L17.085 13.438H17.085L16.5562 12.9062ZM18.9728 12.5894L18.6146 13.2483L18.9728 12.5894ZM20.8833 13.628L20.5251 14.2869L20.8833 13.628ZM21.4217 16.883L21.9505 17.4148L21.4217 16.883ZM20.0011 18.2954L19.4723 17.7636L20.0011 18.2954ZM18.6763 18.9651L18.7459 19.7119H18.7459L18.6763 18.9651ZM8.81536 14.7266L9.34418 14.1947L8.81536 14.7266ZM4.00289 5.74561L3.2541 5.78816L3.2541 5.78816L4.00289 5.74561ZM10.4775 7.19738L11.0063 7.72922H11.0063L10.4775 7.19738ZM10.6342 4.54348L11.2346 4.09401L10.6342 4.54348ZM9.37326 2.85908L8.77286 3.30855V3.30855L9.37326 2.85908ZM6.26145 2.57483L6.79027 3.10667H6.79027L6.26145 2.57483ZM4.69185 4.13552L4.16303 3.60368H4.16303L4.69185 4.13552ZM12.0631 11.4972L12.5919 10.9654L12.0631 11.4972ZM16.6295 13.8909L17.085 13.438L16.0273 12.3743L15.5719 12.8272L16.6295 13.8909ZM18.6146 13.2483L20.5251 14.2869L21.2415 12.9691L19.331 11.9305L18.6146 13.2483ZM20.8929 16.3511L19.4723 17.7636L20.5299 18.8273L21.9505 17.4148L20.8929 16.3511ZM18.6067 18.2184C17.1568 18.3535 13.4056 18.2331 9.34418 14.1947L8.28654 15.2584C12.7186 19.6653 16.9369 19.8805 18.7459 19.7119L18.6067 18.2184ZM9.34418 14.1947C5.4728 10.3453 4.83151 7.10765 4.75168 5.70305L3.2541 5.78816C3.35456 7.55599 4.14863 11.144 8.28654 15.2584L9.34418 14.1947ZM10.7195 8.01441L11.0063 7.72922L9.9487 6.66555L9.66189 6.95073L10.7195 8.01441ZM11.2346 4.09401L9.97365 2.40961L8.77286 3.30855L10.0338 4.99296L11.2346 4.09401ZM5.73263 2.04299L4.16303 3.60368L5.22067 4.66736L6.79027 3.10667L5.73263 2.04299ZM10.1907 7.48257C9.66189 6.95073 9.66117 6.95144 9.66045 6.95216C9.66021 6.9524 9.65949 6.95313 9.659 6.95362C9.65802 6.95461 9.65702 6.95561 9.65601 6.95664C9.65398 6.95871 9.65188 6.96086 9.64972 6.9631C9.64539 6.96759 9.64081 6.97245 9.63599 6.97769C9.62634 6.98816 9.61575 7.00014 9.60441 7.01367C9.58174 7.04072 9.55605 7.07403 9.52905 7.11388C9.47492 7.19377 9.41594 7.2994 9.36589 7.43224C9.26376 7.70329 9.20901 8.0606 9.27765 8.50305C9.41189 9.36833 10.0078 10.5113 11.5343 12.0291L12.5919 10.9654C11.1634 9.54499 10.8231 8.68059 10.7599 8.27309C10.7298 8.07916 10.761 7.98371 10.7696 7.96111C10.7748 7.94713 10.7773 7.9457 10.7709 7.95525C10.7677 7.95992 10.7624 7.96723 10.7541 7.97708C10.75 7.98201 10.7451 7.98759 10.7394 7.99381C10.7365 7.99692 10.7335 8.00019 10.7301 8.00362C10.7285 8.00534 10.7268 8.00709 10.725 8.00889C10.7241 8.00979 10.7232 8.0107 10.7223 8.01162C10.7219 8.01208 10.7212 8.01278 10.7209 8.01301C10.7202 8.01371 10.7195 8.01441 10.1907 7.48257ZM11.5343 12.0291C13.0613 13.5474 14.2096 14.1383 15.0763 14.2713C15.5192 14.3392 15.8763 14.285 16.1472 14.1841C16.28 14.1346 16.3858 14.0763 16.4658 14.0227C16.5058 13.9959 16.5392 13.9704 16.5663 13.9479C16.5799 13.9367 16.5919 13.9262 16.6024 13.9166C16.6077 13.9118 16.6126 13.9073 16.6171 13.903C16.6194 13.9008 16.6215 13.8987 16.6236 13.8967C16.6246 13.8957 16.6256 13.8947 16.6266 13.8937C16.6271 13.8932 16.6279 13.8925 16.6281 13.8923C16.6288 13.8916 16.6295 13.8909 16.1007 13.359C15.5719 12.8272 15.5726 12.8265 15.5733 12.8258C15.5735 12.8256 15.5742 12.8249 15.5747 12.8244C15.5756 12.8235 15.5765 12.8226 15.5774 12.8217C15.5793 12.82 15.581 12.8183 15.5827 12.8166C15.5862 12.8133 15.5895 12.8103 15.5926 12.8074C15.5988 12.8018 15.6044 12.7969 15.6094 12.7929C15.6192 12.7847 15.6265 12.7795 15.631 12.7764C15.6403 12.7702 15.6384 12.773 15.6236 12.7785C15.5991 12.7876 15.501 12.8189 15.3038 12.7886C14.8905 12.7253 14.02 12.3853 12.5919 10.9654L11.5343 12.0291ZM9.97365 2.40961C8.95434 1.04802 6.94996 0.83257 5.73263 2.04299L6.79027 3.10667C7.32195 2.578 8.26623 2.63181 8.77286 3.30855L9.97365 2.40961ZM4.75168 5.70305C4.73201 5.35694 4.89075 4.9954 5.22067 4.66736L4.16303 3.60368C3.62571 4.13795 3.20329 4.89425 3.2541 5.78816L4.75168 5.70305ZM19.4723 17.7636C19.1975 18.0369 18.9029 18.1908 18.6067 18.2184L18.7459 19.7119C19.4805 19.6434 20.0824 19.2723 20.5299 18.8273L19.4723 17.7636ZM11.0063 7.72922C11.9908 6.7503 12.064 5.2019 11.2346 4.09401L10.0338 4.99295C10.4373 5.53193 10.3773 6.23938 9.9487 6.66555L11.0063 7.72922ZM20.5251 14.2869C21.3429 14.7315 21.4703 15.7769 20.8929 16.3511L21.9505 17.4148C23.2908 16.0821 22.8775 13.8584 21.2415 12.9691L20.5251 14.2869ZM17.085 13.438C17.469 13.0562 18.0871 12.9616 18.6146 13.2483L19.331 11.9305C18.2474 11.3414 16.9026 11.5041 16.0273 12.3743L17.085 13.438Z"
                      fill="rgb(29, 65, 48)"
                    />
                  </svg>
                </div>
                <p className="fw-bold mb-2">Phone Number</p>
                <p className="location-text">+(27) 80 365 1198</p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card card-two contact-card text-center">
                <div className="icon-wrapper mb-3">
                  <svg
                    width="100%"
                    height="8vh"
                    viewBox="0 -4 32 32"
                    version="1.1"
                  >
                    <title>mail</title>
                    <desc>Created with Sketch Beta.</desc>
                    <defs></defs>
                    <g
                      id="Page-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Icon-Set"
                        transform="translate(-412.000000, -259.000000)"
                        fill="rgb(232, 237, 235)"
                      >
                        <path
                          d="M442,279 C442,279.203 441.961,279.395 441.905,279.578 L433,270 L442,263 L442,279 L442,279 Z M415.556,280.946 L424.58,271.33 L428,273.915 L431.272,271.314 L440.444,280.946 C440.301,280.979 415.699,280.979 415.556,280.946 L415.556,280.946 Z M414,279 L414,263 L423,270 L414.095,279.578 C414.039,279.395 414,279.203 414,279 L414,279 Z M441,261 L428,271 L415,261 L441,261 L441,261 Z M440,259 L416,259 C413.791,259 412,260.791 412,263 L412,279 C412,281.209 413.791,283 416,283 L440,283 C442.209,283 444,281.209 444,279 L444,263 C444,260.791 442.209,259 440,259 L440,259 Z"
                          id="mail"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <p className="fw-bold mb-2">Email Address</p>
                <p className="location-text">info@ecosphere.com</p>
              </div>
            </div>
            <div className="col-12 col-md-4 mb-4">
              <div className="card card-three contact-card text-center">
                <div className="icon-wrapper mb-3">
                  <svg
                    fill="rgb(29, 65, 48)"
                    width="100%"
                    height="8vh"
                    viewBox="0 0 32 32"
                    version="1.1"
                  >
                    <path d="M16.114-0.011c-6.559 0-12.114 5.587-12.114 12.204 0 6.93 6.439 14.017 10.77 18.998 0.017 0.020 0.717 0.797 1.579 0.797h0.076c0.863 0 1.558-0.777 1.575-0.797 4.064-4.672 10-12.377 10-18.998 0-6.618-4.333-12.204-11.886-12.204zM16.515 29.849c-0.035 0.035-0.086 0.074-0.131 0.107-0.046-0.032-0.096-0.072-0.133-0.107l-0.523-0.602c-4.106-4.71-9.729-11.161-9.729-17.055 0-5.532 4.632-10.205 10.114-10.205 6.829 0 9.886 5.125 9.886 10.205 0 4.474-3.192 10.416-9.485 17.657zM16.035 6.044c-3.313 0-6 2.686-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zM16.035 16.044c-2.206 0-4.046-1.838-4.046-4.044s1.794-4 4-4c2.207 0 4 1.794 4 4 0.001 2.206-1.747 4.044-3.954 4.044z"></path>
                  </svg>
                </div>
                <p className="fw-bold mb-2">Our Office</p>
                <p className="location-text">2443 Oak Ridge Centurion, 0157</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        data-aos="fade-up"
        data-aos-delay="400"
        data-aos-duration="1500"
        className="map"
      >
        <div className="container">
          <div
            className="card"
            style={{
              border: "2px solid rgb(29, 65, 48, 0.8)",
              borderRadius: "10px",
              overflow: "hidden",
            }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d114889.13607782869!2d27.993784745861642!3d-25.860079193634636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1e957b0df5954b27%3A0x474f6dba7062227f!2sCenturion!5e0!3m2!1sen!2sza!4v1749235319320!5m2!1sen!2sza"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
